import { formatRoleName } from '../../../common';
import { createSchemaStatementHandler } from '../../createSchemaStatementHandler';
import { adminRoleName } from '../../utils';
export const renameRoleStmtInstruction = `
####  Renaming roles
- Syntax: \`rename role <role_name> to <new_role_name>;\
- Example: \`rename role editor to contributor;\`
`;
export const stmtRenameRole = ({ role, newRole }) => {
    return `rename role ${role} to ${newRole};`;
};
export const stmtForHumanRenameRole = ({ role, newRole }) => {
    return `Rename the role __${role}__ to __${newRole}__.`;
};
export const renameRoleHandler = createSchemaStatementHandler({
    type: 'rename role',
    parse: line => {
        const match = /^rename role (?<roleName>\w+) to (?<newRoleName>\w+)/.exec(line);
        return match?.groups
            ? {
                type: 'rename role',
                role: formatRoleName(match.groups.roleName),
                newRole: formatRoleName(match.groups.newRoleName),
            }
            : null;
    },
    getHumanStmt: stmtForHumanRenameRole,
    apply: (stmt, builder) => {
        if (stmt.newRole === adminRoleName) {
            throw new Error(`Role ${stmt.role} is reserved. Admin role is automatically created and has all permissions. You can't modify it.`);
        }
        builder.updateSchema(it => {
            return it.renameAclRole(stmt.role, stmt.newRole);
        });
    },
});
//# sourceMappingURL=RenameRoleStmt.js.map